/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './FormikTextArea.style';

const useStyles = createUseStyles(styles);

type Props = {
  className: string,
  field: Object,
  inputProps: Object,
  isHighlighted: boolean,
  handleFocus: () => void,
  handleBlur: () => void,
};

const FormikInput = ({
  className,
  field,
  inputProps,
  isHighlighted,
  handleFocus,
  handleBlur,
}: Props): React.Node => {
  /*
   |------------------------------------------------------------------------------
   | Classes
   |------------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  const rootClasses = classNames(className, {
    [classes['root-isHighlighted']]: isHighlighted,
  });

  /*
    |------------------------------------------------------------------------------
    | Elements
    |------------------------------------------------------------------------------
    */

  return (
    <textarea
      className={rootClasses}
      {...field}
      {...inputProps}
      onFocus={handleFocus}
      onBlur={(e) => {
        field.onBlur(e);

        handleBlur();
      }}
    />
  );
};

export default compose(React.memo)(FormikInput);
